import { render, staticRenderFns } from "./subject-info-panel.vue?vue&type=template&id=33649348"
import script from "./subject-info-panel.ts?vue&type=script&lang=ts&external"
export * from "./subject-info-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./subject-info-panel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports